import type { FormatSettings } from './session-note.models';

export const DEFAULT_FORMAT_SETTINGS: FormatSettings = {
    format: 'narrative',
    length: 'concise',
    identifier: 'client',
};
